import { useState } from 'react'
import { useApplications, useReview } from '@/hooks/useAffiliate'

/** The affiliate review queue. Approval is by hand, and every application is read. */
export function AdminAffiliates() {
  const [status, setStatus] = useState<'pending' | 'approved' | 'declined'>('pending')
  const { data: apps, isLoading, error } = useApplications(status)
  const review = useReview()
  const [reasons, setReasons] = useState<Record<string, string>>({})
  const [err, setErr] = useState<string | null>(null)

  return (
    <div className="admin-page">
      <h1>Affiliate applications</h1>
      <div className="admin-tabs" style={{ display: 'flex', gap: 8, margin: '12px 0 18px' }}>
        {(['pending', 'approved', 'declined'] as const).map((s) => (
          <button key={s} className={`btn ${status === s ? 'btn--amber' : 'btn--ghost'}`} onClick={() => setStatus(s)}>{s}</button>
        ))}
      </div>
      {isLoading && <p>Loading.</p>}
      {error && <p className="error">{(error as Error).message}</p>}
      {err && <p className="error">{err}</p>}
      {apps?.length === 0 && <p>Nothing {status}.</p>}
      <div style={{ display: 'grid', gap: 14 }}>
        {apps?.map((a) => (
          <div key={a.id} className="admin-card" style={{ padding: 16, border: '1px solid var(--hair)', borderRadius: 12, background: 'var(--card)' }}>
            <strong>{a.users?.full_name ?? a.users?.email}</strong> · {a.users?.email}
            <div style={{ fontSize: 13, color: 'var(--muted)', margin: '4px 0 10px' }}>
              {a.clients?.display_name} · {a.clients?.city_state} · {a.clients?.plan_id ?? 'no plan'} · applied {new Date(a.created_at).toLocaleDateString()}
            </div>
            <dl style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: '6px 12px', fontSize: 14 }}>
              <dt>Channels</dt><dd>{a.channels.join(', ') || 'none'}</dd>
              <dt>Audience size</dt><dd>{a.audience_size ?? 'not given'}</dd>
              <dt>Where they post</dt><dd>{a.profile_url ? <a href={a.profile_url.startsWith('http') ? a.profile_url : `https://${a.profile_url}`} target="_blank" rel="noreferrer">{a.profile_url}</a> : 'not given'}</dd>
              <dt>Who they'd recommend</dt><dd>{a.audience_desc || 'not given'}</dd>
              <dt>How they'd bring it up</dt><dd>{a.approach_desc || 'not given'}</dd>
              <dt>Requested code</dt><dd><code>{a.requested_code}</code></dd>
              <dt>Agreements</dt><dd>{Object.keys(a.agreements ?? {}).length} of 4</dd>
            </dl>
            {status === 'pending' && (
              <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                <input placeholder="Reason, if declining" value={reasons[a.id] ?? ''} onChange={(e) => setReasons({ ...reasons, [a.id]: e.target.value })} style={{ flex: 1, minWidth: 200 }} />
                <button className="btn btn--ghost" disabled={review.isPending} onClick={() => { setErr(null); review.mutate({ id: a.id, approve: false, reason: reasons[a.id] }, { onError: (e) => setErr((e as Error).message) }) }}>Decline</button>
                <button className="btn btn--amber" disabled={review.isPending} onClick={() => { setErr(null); review.mutate({ id: a.id, approve: true }, { onError: (e) => setErr((e as Error).message) }) }}>Approve</button>
              </div>
            )}
            {a.decline_reason && <p style={{ marginTop: 8 }}>Declined: {a.decline_reason}</p>}
          </div>
        ))}
      </div>
    </div>
  )
}
